import React, { useState, useRef, useEffect } from 'react'
import { PropTypes } from 'prop-types'
import classNames from 'classnames'
import { Icon } from '../..'
import { useTranslation } from '../../../utils'

const SubCategoryCarousel = ({ children, className }) => {
  const [isPrevInvisible, setPrevInvisible] = useState(false)
  const [isNextInvisible, setNextInvisible] = useState(false)
  const sliderRef = useRef(null)
  const { t } = useTranslation()

  const updateButtonVisibility = (
    offsetWidthValue,
    scrollWidthValue,
    scrollLeft = 0
  ) => {
    let leftFlag = true
    let rightFlag = true

    if (offsetWidthValue < scrollWidthValue) {
      leftFlag = scrollLeft <= 0
      rightFlag = scrollLeft + offsetWidthValue >= scrollWidthValue
    }
    setPrevInvisible(leftFlag)
    setNextInvisible(rightFlag)
  }

  const handleClick = (direction) => {
    if (!sliderRef?.current) return

    const { offsetWidth, scrollWidth, scrollLeft } = sliderRef.current
    const newScrollLeft =
      direction === 'left'
        ? scrollLeft - offsetWidth / 2
        : scrollLeft + offsetWidth / 2

    sliderRef.current.scrollLeft = newScrollLeft
    updateButtonVisibility(offsetWidth, scrollWidth, newScrollLeft)
  }

  const sliderContainerClasses = classNames(
    'sub-category-carousel__container',
    className,
    {
      'justify-content-center': isPrevInvisible && isNextInvisible,
      'ml-5': !isPrevInvisible,
      'mr-5': !isNextInvisible,
    }
  )
  const prevButtonTitle = t('PREV')
  const nextButtonTitle = t('NEXT')

  useEffect(() => {
    if (sliderRef?.current) {
      const { offsetWidth, scrollWidth } = sliderRef.current
      updateButtonVisibility(offsetWidth, scrollWidth)
    }
  }, [children])

  return (
    <div className={sliderContainerClasses} ref={sliderRef}>
      <div className="sub-category-carousel__wrapper">{children}</div>
      <button
        className={`sub-category-carousel__arrow sub-category-carousel__arrow--left ${
          isPrevInvisible ? 'd-none' : ''
        }`}
        onClick={() => handleClick('left')}
        title={prevButtonTitle}
        aria-label={prevButtonTitle}
      >
        <Icon symbol="cf-prev" />
      </button>

      <button
        className={`sub-category-carousel__arrow sub-category-carousel__arrow--right ${
          isNextInvisible ? 'd-none' : ''
        }`}
        onClick={() => handleClick('right')}
        title={nextButtonTitle}
        aria-label={nextButtonTitle}
      >
        <Icon symbol="cf-next" />
      </button>
    </div>
  )
}

SubCategoryCarousel.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

export default SubCategoryCarousel
